export default {"src":"/_next/static/media/section3-img2.871ecdcf.svg","height":206,"width":219,"blurWidth":0,"blurHeight":0};